import http from '@/http'
import normalizeFields from '@/utils/normalizeFields'
const defaultError = 'Não foi possível completar a requisição'

export const actions = {
  /**
   * Get providers
   * @function
   */
  getAdminProviders () {
    return http.get('/api/admin/providers').then(response => {
      if (response.status === 200) {
        return Promise.resolve(response.data)
      }
    }).catch(error => {
      const message = (error.response.data.message) ? error.response.data.message : defaultError
      return Promise.reject(message)
    })
  },

  /**
   * Get providers fields by provider and company
   * @function
   * @param {string} companyId - company id
   * @param {string} providerId - provider id
   */
  getAdminProviderManage (context, { companyId, providerId }) {
    // MOCK
    // console.log(context, companyId, providerId)
    // const result = require('@/__helpers__/provider-sabre.json')
    // const { provider, active } = result
    // const fields = result.fields
    //   .sort((a, b) => b.type.localeCompare(a.type))
    //   .sort((a, b) => a.field.localeCompare(b.field))
    // return Promise.resolve({ provider, active, fields })
    return http.get(`/api/admin/provider/manage?company_id=${companyId}&provider=${providerId}`)
      .then(response => {
        if (response.status === 200) {
          const data = response.data
          const fields = normalizeFields(response.data.fields)
          return Promise.resolve({ ...data, fields })
        }
      })
      .catch(error => {
        const message = (error.response.data.message) ? error.response.data.message : defaultError
        return Promise.reject(message)
      })
  },

  /**
   * Post provider
   * @function
   * @param {object} data - Form data
   */
  postAdminProviderManage (context, data) {
    return http.post('/api/admin/provider/manage', { ...data }).then(response => {
      if (response.status === 200) {
        return Promise.resolve(response.data.message)
      }
    }).catch(error => {
      // const message = (error.response.data.message) ? error.response.data.message : defaultError
      const message = (error.response.data.resolution)
        ? error.response.data.resolution
        : (error.response.data.message) ? error.response.data.message : defaultError
      return Promise.reject(message)
    })
  }
}

export default {
  namespaced: true,
  actions
}
